module.exports = __webpack_public_path__ + "static/img/5-5.ef077bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-5.png
// module id = Y8Zd
// module chunks = 25